<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <section class="content-header">
        <ol class="breadcrumb">
          <li>
            <router-link to="/">
              <i class="ti-home"></i>
            </router-link>
          </li>
          <li>
            <router-link :to="{name:'devices'}">Devices</router-link>
          </li>
          <li class="active">
            <a href="#">View Device</a>
          </li>
        </ol>
      </section>
      <!-- Main content -->
      <section class="content device-content">
        <div class="box" v-loading="deviceLoading">
          <div class="box-body">
            <el-form :model="device" ref="device" label-width="120px" label-position="top">
              <el-row :gutter="20">
                <el-col :md="24" :lg="8">
                  <el-form-item label="Name" prop="name">{{device.name}}</el-form-item>
                </el-col>
                <el-col :md="24" :lg="8">
                  <el-form-item label="Serial" prop="serial">{{device.serial}}</el-form-item>
                </el-col>
                <el-col :md="24" :lg="8">
                  <el-form-item label="ICC Id" prop="iccId">{{device.iccId}}</el-form-item>
                </el-col>
              </el-row>
              <hr>
              <el-row :gutter="20">
                <el-col :lg="12">
                  <el-form-item label="Customer" prop="customer.name">{{device.customer.name}}</el-form-item>
                </el-col>
              </el-row>

              <hr>
              <el-form-item label="Channels" prop="channels">
                <el-table :data="device.channels" style="width: 100%">
                  <template slot="empty">
                    <template v-if="!deviceLoading">No channels</template>
                    <template v-else>Loading...</template>
                  </template>
                  <el-table-column label="Name" prop="name"></el-table-column>
                  <el-table-column label="Channel" prop="channelIndex"></el-table-column>
                </el-table>
              </el-form-item>
              <!-- <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm('ruleForm')"
                >Save</el-button>
                <el-button @click="resetForm('ruleForm')">Reset</el-button>
              </el-form-item>-->
            </el-form>
            <hr>
            <h4>Content</h4>
            <div v-loading="contentLoading && !content.length">
              <el-table :data="content" style="width: 100%">
                <template slot="empty">
                  <template v-if="!contentLoading">No content</template>
                  <template v-else>Loading...</template>
                </template>
                <el-table-column label="Created" prop="created">
                  <template v-slot="{row: {created}}">
                    {{ created.format('YYYY-MM-DD HH:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column label="Start" prop="startDateTime">
                  <template v-slot="{row: {startDateTime}}">
                    {{ startDateTime.format('YYYY-MM-DD HH:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column label="Channel">
                  <template v-slot="{row: {channelIndex}}">
                    {{channelNames[channelIndex] || `Index ${channelIndex}`}}
                  </template>
                </el-table-column>
                <el-table-column label="Status">
                  <template scope="scope">
                    <el-tooltip v-if="scope.row.status === 'ERROR' && scope.row.errorReason" class="item"
                      effect="dark" :content="scope.row.errorReason" placement="top">
                      <el-tag size="medium" type="danger">{{scope.row.status}}</el-tag>
                    </el-tooltip>
                    <el-tag v-else size="medium"
                      :type="scope.row.status === 'ERROR' ? 'danger' : scope.row.status === 'COMPLETED' ? 'success' : 'info'">
                      {{scope.row.status}}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="Type" prop="type"></el-table-column>
                <el-table-column label="Duration">
                  <template v-slot="{row: {duration}}">
                    {{ duration.format('HH:mm:ss') }}
                  </template>
                </el-table-column>
                <el-table-column align="right">
                  <template scope="scope">
                    <el-button v-if="scope.row.artifactUrl" size="mini" type="success" icon="el-icon-download"
                      @click="handleContentDownload(scope.row)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="box-footer">
                <el-pagination background :page-size="pagination.pageSize" layout="prev, pager, next, sizes"
                  :total="pagination.totalCount" :page-sizes="pagination.rowsPerPageItems"
                  :current-page="pagination.pageNum" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"></el-pagination>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import { devicesClient } from "@api/devices";
// import { required, minLength, between } from 'vuelidate/lib/validators'
export default {
  name: "device-view",
  props: {
    serial: {
      // type: String,
      required: true
    }
  },
  filters: {
    sec(nano) {
      return (nano * Math.pow(10, -9)).toFixed(2);
    }
  },
  data() {
    return {
      deviceLoading: false,
      contentLoading: false,
      timer: undefined,
      content: [],
      device: {
        serial: "",
        name: "",
        iccId: "",
        channels: []
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
        rowsPerPageItems: [2, 10, 20, 30, 40, 50, 100]
      }
    };
  },

  computed: {
    ...mapGetters("devices", ["list"]),
    channelNames() {
      return this.device.channels.reduce((res, ch) => {
        res[ch.channelIndex] = ch.name;
        return res;
      }, {})
    }
  },

  mounted() {
    this.deviceLoading = true;
    devicesClient
      .getDevice(this.serial)
      .then(deviceResponce => {
        this.device = { ...deviceResponce.data };
        this.deviceLoading = false;
        this.handleContentRefresh();
      })
      .catch(_ => {
        this.deviceLoading = false;
        this.$router.push({ name: "404" });
      });
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  
  methods: {
    handleSizeChange(pageSize) {
      this.pagination = { ...this.pagination, pageSize };
      this.handleContentRefresh(true);
    },
    handleCurrentChange(pageNum) {
      this.pagination = { ...this.pagination, pageNum };
      this.handleContentRefresh(true);
    },
    handleContentRefresh(clear = false) {
      clearTimeout(this.timer);
      this.contentLoading = true
      if (clear) this.content = [];
      const { pageNum, pageSize } = this.pagination;
      devicesClient
        .getContent(this.device.serial, pageNum, pageSize)
        .then(contentResponce => {
          const {
            totalCount,
            pageNum,
            pageSize,
            content
          } = contentResponce.data;
          this.pagination = {
            ...this.pagination,
            totalCount,
            pageNum,
            pageSize
          };
          this.content = contentResponce.data.contents.map(({ created, startDateTime, type, durationNanos, ...other }) => ({
            ...other,
            created: moment(created),
            startDateTime: moment(startDateTime),
            type: type.startsWith('VIDEO') ? 'VIDEO' : 'SNAPSHOT',
            duration: moment.unix(durationNanos / 1000000000, 'seconds').utc()
          }));
          if (this.content.find(x => x.status === 'PENDING')) {
            this.timer = setTimeout(this.handleContentRefresh, 30 * 1000);
          }
          this.contentLoading = false;
        })
        .catch(_ => {
          this.contentLoading = false;
        });
    },
    handleContentDownload(media) {
      window.open(media.artifactUrl, "_blank");
    }
  }
};
</script>



// WEBPACK FOOTER //
// View.vue?7cf7dbbe